/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Empty_TitleInputs */

const en_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cover letters yet`)
};

const de_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Anschreiben`)
};

const fr_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune lettre de motivation pour le moment`)
};

const es_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay cartas de presentación`)
};

const it_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna lettera di presentazione ancora`)
};

const nl_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen motivatiebrieven`)
};

const pl_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak listów motywacyjnych`)
};

const fi_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä saatekirjeitä`)
};

const da_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ansøgningsbreve endnu`)
};

const sv_cover_letters_empty_title = /** @type {(inputs: Cover_Letters_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga personliga brev ännu`)
};

/**
* | output |
* | --- |
* | "No cover letters yet" |
*
* @param {Cover_Letters_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_empty_title = /** @type {((inputs?: Cover_Letters_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_empty_title(inputs)
	if (locale === "fr") return fr_cover_letters_empty_title(inputs)
	if (locale === "es") return es_cover_letters_empty_title(inputs)
	if (locale === "it") return it_cover_letters_empty_title(inputs)
	if (locale === "nl") return nl_cover_letters_empty_title(inputs)
	if (locale === "pl") return pl_cover_letters_empty_title(inputs)
	if (locale === "fi") return fi_cover_letters_empty_title(inputs)
	if (locale === "da") return da_cover_letters_empty_title(inputs)
	if (locale === "sv") return sv_cover_letters_empty_title(inputs)
	return en_cover_letters_empty_title(inputs)
});